import { TagContent } from './tag-content';
import * as Styled from './tag.styles';
import type { DefaultTagProps } from './tag.types';

export const DefaultTag = ({
  children,
  className,
  fontWeight,
  hideBorder,
  leadingIcon: LeadingIcon,
  maxWidth,
  profile,
  trailingIcon: TrailingIcon,
  ...props
}: DefaultTagProps): JSX.Element => {
  const hasChildren = Boolean(children);
  const hasLeadingContent =
    !hasChildren || Boolean(LeadingIcon) || Boolean(profile);
  const hasTrailingContent = !hasChildren || Boolean(TrailingIcon);

  return (
    <Styled.DefaultTag
      $fontWeight={fontWeight}
      $hasLeadingContent={hasLeadingContent}
      $hasTrailingContent={hasTrailingContent}
      $hideBorder={hideBorder}
      className={className}
      data-xds="Tag"
      tabIndex={0}
      {...props}>
      <TagContent
        badgeProps={undefined}
        disabled={false}
        leadingIcon={LeadingIcon && <LeadingIcon width={18} height={18} />}
        maxWidth={maxWidth}
        profile={profile}
        selected={false}
        trailingIcon={TrailingIcon && <TrailingIcon width={18} height={18} />}>
        {children}
      </TagContent>
    </Styled.DefaultTag>
  );
};
